import { COMMON_NS } from "@/i18n/common/common.i18n";
import i18n from "@/i18n/i18n";

export const UNKNOWN_THREAD_KEY = "threads.unknown";

/**
 * Resolve a display label for a thread slug.
 * Attempts to translate `threads.<slug>` within the common namespace.
 * Falls back to the `threads.unknown` message when no translation exists, which
 * happens when the monolith gains a thread before the snapshot is synced.
 */
export const getThreadDisplayLabel = (threadSlug?: string): string => {
  if (!threadSlug) return "";

  const translationKey = `threads.${threadSlug}`;
  // Passing the slug as a defaultValue lets us tell a real translation apart from
  // a missing key, which i18next otherwise signals by echoing the key back.
  const translated = i18n.t(translationKey, threadSlug, { ns: COMMON_NS });

  // If the library returns the key itself OR the defaultValue, treat as missing.
  const missing = translated === translationKey || translated === threadSlug;
  return missing
    ? i18n.t(UNKNOWN_THREAD_KEY, { ns: COMMON_NS, thread: threadSlug })
    : translated;
};

export default getThreadDisplayLabel;
